export default __webpack_public_path__ + "static/retail-customer-service-customer-feedback-0e993ee978531dea08a9da61ac337bcd.jpg";